import { useState } from 'react'
import { Avatar, SxProps, Theme } from '@mui/material'

/**
 * A school's logo. Renders nothing when there isn't one — including when a URL
 * fails to load — so no placeholder occupies the space.
 */
export const SchoolLogo = ({
  name,
  logoUrl,
  size = 40,
  sx,
}: {
  name: string
  logoUrl?: string | null
  size?: number
  sx?: SxProps<Theme>
}) => {
  const [failed, setFailed] = useState(false)

  if (!logoUrl || failed) return null

  return (
    <Avatar
      src={logoUrl}
      alt={name}
      variant="rounded"
      onError={() => setFailed(true)}
      sx={{ width: size, height: size, bgcolor: 'transparent', ...sx }}
    />
  )
}
